import React, { useRef } from 'react';
import { ButtonProps, ControlProps, TooltipProps, Button, Tooltip } from 'lego-on-react';

interface TooltipButtonTooltipProps {
    onOutsideClick?: () => void;
    tooltipVisible?: boolean;
    tooltipLabel?: string;
    tooltipTheme?: TooltipProps['theme'];
    tooltipTo?: TooltipProps['to'];
}

type TooltipButtonProps = ButtonProps & ControlProps & TooltipButtonTooltipProps;

const TooltipButton: React.SFC<TooltipButtonProps> = (props) => {
    const {
        onOutsideClick,
        tooltipVisible,
        tooltipLabel,
        tooltipTheme,
        tooltipTo = 'right',
        size = 's',
        theme = 'action',
        disabled,
        ...restProps
    } = props;

    const buttonRef = useRef(null);

    return (
        <>
            <Button theme={theme} size={size} ref={buttonRef} disabled={disabled || tooltipVisible} {...restProps} />
            {tooltipVisible && Boolean(tooltipLabel) && (
                <Tooltip
                    visible={tooltipVisible}
                    anchor={buttonRef.current!}
                    theme={tooltipTheme}
                    autoclosable
                    onOutsideClick={onOutsideClick}
                    to={tooltipTo}
                    size="s"
                >
                    {tooltipLabel}
                </Tooltip>
            )}
        </>
    );
};

export default TooltipButton;
